import { escrowOfficerCard } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const OROverrides: ListingLocaleOverrides = {
  locale: 'OR',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.lot',
                  size: 50,
                },
                {
                  name: 'property.block',
                  size: 50,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: 'Copy legal description from tax records',
            },
            lot: {
              name: 'property.lot',
              entity: 'property',
              type: 'text',
              label: 'Lot',
              placeholderText: '',
            },
            block: {
              name: 'property.block',
              entity: 'property',
              type: 'text',
              label: 'Block',
              placeholderText: '',
            },
          },
        },
        salesPriceCard: {
          layout: [
            [
              {
                name: 'salesPrice',
                size: 100,
              },
            ],
            [
              {
                name: 'salesAgreementNumber',
                size: 100,
              },
            ],
          ],
          fields: {
            salesAgreementNumber: {
              name: 'salesAgreementNumber',
              entity: 'interaction',
              type: 'text',
              label: 'Sales Agreement Number',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: () => escrowOfficerCard,
      },
    },
  },
};
